import { takeLatest, call, put } from "redux-saga/effects";
import {
  authUserBegin,
  authUserSuccess,
  authUserError,
  authUserAccess,
} from "./slice";
import { apiPost } from "../../api/callApi";
import { auth, setUserAccess, GoogleAuthAction, LogoutAction } from "./actions";
import {
  readFromLocalStorage,
  saveToLocalStorage,
  showAlert,
} from "utils/helper";

function* authUser(val) {
  yield put(authUserBegin());
  try {
    const data = val.payload;
    const response = yield call(apiPost, "/v1/login", data);
    if (response) {
      yield put(authUserSuccess(response));
      // Save user data to localStorage
      saveToLocalStorage("user", JSON.stringify(response));

      // Trigger login event for other tabs
      saveToLocalStorage("login-event", Date.now());
    } else {
      yield put(authUserError(response.message || "Login failed"));
    }
  } catch (error) {
    console.error("Caught error:", error.message);
    yield put(
      authUserError(error?.response?.data?.message || "An error occurred")
    );
  }
}

function* googleAuth(val) {
  try {
    // const data = val.payload;
    const { data, callback } = val.payload;

    const response = yield call(apiPost, "/v1/loginwithgoogle", data);
    if (response) {
      yield put(authUserSuccess(response));
      if (callback) callback(true);
    } else {
      yield put(authUserError(response.message || "Login failed"));
      if (callback) callback(false);
    }
  } catch (error) {
    console.error("Caught error:", error.message);
    showAlert({
      title: "Error",
      text: error?.response?.data?.message || error.message,
      icon: "error",
    });
    // if (typeof val.payload?.callback === "function") {
    //   val.payload.callback(false);
    // }
    if (val.callback) val.callback(false);
  }
}

function* UserAccess({ payload }) {
  try {
    const data = payload;
    yield put(authUserAccess(data));
  } catch (error) {
    yield put(authUserAccess(0));
  }
}

function* Logout({ payload }) {
  try {
    const shouldBroadcast = payload?.broadcast !== false;
    const tempuserName = readFromLocalStorage("userName");
    const remember = readFromLocalStorage("remember");
    localStorage.clear();
    sessionStorage.clear();

    if (remember === "1") {
      saveToLocalStorage("userName", tempuserName);
      saveToLocalStorage("remember", remember);
    } else {
      localStorage.removeItem("remember");
      localStorage.removeItem("userName");
    }

    if (shouldBroadcast) {
      saveToLocalStorage("logout-event", Date.now());
    }

    window.location = "/";
  } catch (error) {
    alert("something went wrong");
  }
}

export function* watchAuthUser() {
  yield takeLatest(auth.type, authUser);
  yield takeLatest(setUserAccess.type, UserAccess);
  yield takeLatest(GoogleAuthAction.type, googleAuth);
  yield takeLatest(LogoutAction.type, Logout);
}
